// extracted by mini-css-extract-plugin
export default {"melodyVideo":"mN-z","isFullWidth":"nN-z","landingPageVideo":"oN-z","play":"pN-z","iframeVideo":"qN-z","playHidden":"rN-z","fullwidth":"sN-z"};